import { render, staticRenderFns } from "./UnitFlag.vue?vue&type=template&id=2697634e&"
import script from "./UnitFlag.vue?vue&type=script&lang=js&"
export * from "./UnitFlag.vue?vue&type=script&lang=js&"
import style0 from "./UnitFlag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports